/* eslint-disable */

import ZJConfig from '../../config'

//ZJUploader 类
export default (function (win) {
    var SLICE_NUM_PER_REQ = 20; //每次请求合并多少个分片
    var pt;

    if (win.ZJUploader)
        return win.ZJUploader;

    const getApiUrl = function () {
        let url = ZJConfig.current.getValue('api.base_url', '');
        if (url) {
            url += '/msapi/v1.0/FileService';
        }
        return url;
    }

    function ZJUploader(opts) {
        this.config = Object.assign({
            url: ZJUploader.getApiUrl(),
            //是否使用 $.zjMsInvoke 来调用 API。
            // zjMsInvoke 内部编码分片数据为 base64 字符串，
            // 这会使得上传流量增大约 4/3 （三分之四）倍。
            useMsInvoke: false,
            file: null, //File 实例
            sliceSize: 512 * 1024, //分片大小 128K
            sliceNumPerReq: SLICE_NUM_PER_REQ,
            fileID: "", //文件 ID
            module: "", //模块名
            submodule: "", //子模块
            assocID: "", //业务ID
            uploader: "", //上传人
            folder: "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
            ext1: "", //扩展字段 1
            ext2: "", //扩展字段 2
            ext3: 0, //扩展字段 3
            progress: function (d) { } //进度回调
        }, this.config, opts);

        //进度信息
        this.prg = {
            status: "",
            errmsg: "",
            upload: 0,
            total: 0,
            text: ""
        };

        //分片信息
        this.slices = [];
    }

    pt = ZJUploader.prototype;

    //执行上传
    pt.upload = function () {
        var that = this,
            prg = that.prg;
        if (prg.status) {
            throw new Error("已经执行过 upload() 方法，如需恢复/重试，请使用 resume() 或 retry() 方法");
        }

        prg.status = "uploading";
        prg.errmsg = "";
        prg.total = 0;
        prg.upload = 0;
        prg.text = "";

        return new Promise(function (resolve, reject) {
            var file = that.config.file;
            if (!file || (Object.prototype.toString.call(file) !== "[object File]")) {
                prg.status = "error";
                prg.errmsg = "无待上传的文件，或者文件不是 File 类型的实例";
                that._updateProgress();
                reject(prg.errmsg, that);
                return;
            }

            var fileSize = file.size;

            if (fileSize < 1) {
                prg.status = "error";
                prg.errmsg = "文件的长度为 0 字节";
                reject(prg.errmsg, that);
                return;
            }

            var sliceSize = parseInt(that.config.sliceSize) || 0;

            that.slices = [];
            that.fileName = file.name;
            that.fileType = file.type;
            that.fileSize = file.size;
            //console.log("Filename: " + file.name);
            //console.log("Type: " + file.type);
            //console.log("Size: " + file.size + " bytes");
            //console.log("sliceSize: " + sliceSize + " bytes");

            prg.total = sliceSize > 0 ? Math.ceil(fileSize / sliceSize) : 1;
            prg.upload = 0;
            prg.text = "计算分片...";
            that._updateProgress();

            if (sliceSize > 0 && fileSize > sliceSize) {
                var offset = 0;

                for (; offset < fileSize; offset += sliceSize) {
                    that.slices.push({
                        start: offset,
                        end: Math.min(offset + sliceSize, fileSize),
                        fid: null
                    });
                    prg.upload++;
                    that._updateProgress();
                }
            }
            else {
                that.slices.push({
                    start: 0,
                    end: fileSize,
                    fid: null
                });
                prg.upload++;
                that._updateProgress();
            }

            prg.total = fileSize;
            prg.upload = 0;
            prg.text = "上传中...";
            that._updateProgress();

            that.index = 0; //从 0 开始上传分片
            that._upload(resolve, reject);
        });
    };

    //暂停上传。如果正在执行合并分片操作，则禁止暂停。
    pt.pause = function () {
        var that = this,
            prg = that.prg;
        return new Promise(function (resolve, reject) {
            if (prg.status != "uploading" && prg.status != "combining") {
                switch (prg.status) {
                    case "pausing":
                    case "pause":
                        reject("重复暂停", that);
                        break;
                    case "success":
                        reject("上传已经成功", that);
                        break;
                    case "error":
                        reject(prg.errmsg, that);
                        break;
                    default:
                        reject("还未开始上传", that);
                        break;
                }
                return;
            }
            that._pauseState = {
                resolve: resolve,
                reject: reject
            };
            prg.status = "pausing";
            prg.text = "暂停中...";
            that._updateProgress();
        });
    };

    //恢复上传
    pt.resume = function () {
        var that = this,
            prg = that.prg;
        return new Promise(function (resolve, reject) {
            if (prg.status != "pause") {
                reject("未处于暂停状态", that);
                return;
            }
            prg.status = "uploading";
            prg.text = "上传中...";
            that._updateProgress();
            that._pauseState = null;
            that._upload(resolve, reject);
        });
    };

    //重试上传
    pt.retry = function () {
        var that = this,
            prg = that.prg;
        return new Promise(function (resolve, reject) {
            if (prg.status != "error") {
                reject("未处于出错状态", that);
                return;
            }
            prg.status = "uploading";
            prg.text = "上传中...";
            that._updateProgress();
            that._upload(resolve, reject);
        });
    };

    //重置对象
    //调用前，请确保不处于上传状态
    pt.reset = function () {
        var that = this,
            prg = that.prg;

        if (prg.status &&
            prg.status != "pause" &&
            prg.status != "success" &&
            prg.status != "error") {
            throw new Error(
                "对象处于 " + prg.status + " 状态，" +
                "不允许重置或释放，请等待上传完成或暂停后再重置或释放对象");
        }

        prg.status = "";
        prg.errmsg = "";
        prg.total = 0;
        prg.upload = 0;
        prg.text = "";

        that.slices = [];
        that.fileName = "";
        that.fileType = "";
        that.fileSize = 0;
        that.index = -1;
        that.result = null;
    };

    //释放掉对象
    //调用前，请确保不处于上传状态
    pt.destroy = function () {
        this.reset();
    };

    pt._upload = function (resolve, reject) {
        var that = this,
            prg = that.prg;
        that._uploadSlices(function (r) {
            prg.status = "combining";
            prg.total = that.slices.length;
            prg.upload = 0;
            prg.text = "合并分片...";
            that._updateProgress();
            that._createSuperSlice(function (r) {
                that.slices = [{
                    start: 0,
                    end: r.SliceSize,
                    fid: r.SliceID
                }];
                that.index = 1;
                that._createSuperFile(function (r) {
                    that.result = r;
                    prg.status = "success";
                    prg.text = "上传完成";
                    that._updateProgress();
                    resolve(r, that);
                }, function (r) {
                    prg.status = "error";
                    prg.errmsg = "合并分片时出错";
                    that._updateProgress();
                    reject(prg.errmsg, that);
                });
            }, function (r) {
                if (prg.status == "pause") {
                    //do nothing
                }
                else {
                    prg.status = "error";
                    prg.errmsg = "合并分片时出错";
                    that._updateProgress();
                }
                reject(prg.errmsg, that);
            });
        }, function (r) {
            if (prg.status == "pause") {
                //do nothing
            }
            else {
                prg.status = "error";
                prg.errmsg = "上传出错";
                that._updateProgress();
            }
            reject(prg.errmsg, that);
        });
    };

    //更新进度条。
    pt._updateProgress = function () {
        var that = this,
            prg = that.prg;
        if (typeof (that.config.progress) === "function") {
            that.config.progress.apply(that, [prg]);
        }
    };

    //创建超级分片
    pt._createSuperSlice = function (resolve, reject) {
        var that = this,
            config = that.config,
            slices = that.slices,
            len = slices.length,
            num = Math.min(len, Math.max(2, config.sliceNumPerReq || SLICE_NUM_PER_REQ)),
            data = {
                State: JSON.stringify({
                    num: num
                }),
                Slices: []
            },
            slice;

        if (slices.length > 1) {
            for (var i = 0; i < num; i++) {
                slice = slices[i];
                data.Slices.push(slice.fid);
            }
            that._combinSlices(data, function (r) {
                var st = JSON.parse(r.State);
                that.slices.splice(1, st.num - 1);
                that.slices[0].end = r.SliceSize;
                that.slices[0].fid = r.SliceID;
                that.index -= (st.num - 1);
                //暂停成功
                if (that.prg.status == "pausing") {
                    that.prg.status = "pause";
                    that.prg.text = "暂停上传";
                    that.prg.errmsg = "暂停上传";
                    that._updateProgress();
                    if (that._pauseState && that._pauseState.resolve) {
                        that._pauseState.resolve(true, that);
                        that._pauseState.resolve = null;
                        that._pauseState.reject = null;
                    }
                    reject(that.prg.errmsg, that);
                    that.prg.upload += (st.num - 1);
                }
                else {
                    that.prg.upload += (st.num - 1);
                    that._updateProgress();
                    that._createSuperSlice(resolve, reject);
                }
            }, function (errmsg) {
                //暂停失败
                if (that.prg.status == "pausing") {
                    if (that._pauseState && that._pauseState.reject) {
                        that._pauseState.reject("合并分片时出错", that);
                        that._pauseState.resolve = null;
                        that._pauseState.reject = null;
                    }
                }
                reject(errmsg, that);
            });
        }
        else {
            //禁止暂停
            if (that.prg.status == "pausing") {
                if (that._pauseState && that._pauseState.reject) {
                    that._pauseState.reject("禁止暂停", that);
                    that._pauseState.resolve = null;
                    that._pauseState.reject = null;
                }
            }
            that.prg.upload = that.prg.total;
            that._updateProgress();
            resolve({
                SliceID: that.slices[0].fid,
                SliceSize: that.slices[0].end,
                State: ""
            }, that);
        }
    };

    pt._combinSlices = function (data, resolve, reject) {
        var that = this,
            config = that.config;
        if (config.useMsInvoke) {
            that._callMsCreateSuperSliceApi(data, resolve, reject);
        }
        else {
            that._callRawCreateSuperSliceApi(data, resolve, reject);
        }
    };

    pt._callRawCreateSuperSliceApi = function (data, resolve, reject) {
        this._post(
            "/File/CreateSuperSlice",
            JSON.stringify(data),
            resolve, reject,
            "application/json");
    };

    pt._callMsCreateSuperSliceApi = function (data, resolve, reject) {
        this._zjMsInvoke(
            "/File/CreateSuperSlice",
            JSON.stringify(data),
            resolve,
            reject);
    };

    //创建超级文件
    pt._createSuperFile = function (resolve, reject) {
        var that = this,
            config = that.config,
            slices = that.slices,
            data = {
                FileID: config.fileID || "", //文件 ID
                Module: config.module || "", //模块名
                SubModule: config.submodule || "", //子模块
                AssocID: config.assocID || "", //业务ID
                FileName: that.fileName || "", //文件名
                Uploader: config.uploader || "", //上传人
                Folder: config.folder || "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
                Extends1: config.ext1 || "", //扩展字段 1
                Extends2: config.ext2 || "", //扩展字段 2
                Extends3: config.ext3 || 0, //扩展字段 3
                Slices: []
            },
            slice;

        for (var i = 0; i < slices.length; i++) {
            slice = slices[i];
            data.Slices.push(slice.fid);
        }

        if (config.useMsInvoke) {
            that._callMsCreateSuperFileApi(data, resolve, reject);
        }
        else {
            that._callRawCreateSuperFileApi(data, resolve, reject);
        }
    };

    pt._callRawCreateSuperFileApi = function (data, resolve, reject) {
        this._post(
            "/File/CreateSuperFile",
            JSON.stringify(data),
            resolve, reject,
            "application/json");
    };

    pt._callMsCreateSuperFileApi = function (data, resolve, reject) {
        this._zjMsInvoke(
            "/File/CreateSuperFile",
            JSON.stringify(data),
            resolve,
            reject);
    };

    //依次上传分片
    pt._uploadSlices = function (resolve, reject) {
        var that = this,
            slices = that.slices,
            len = slices.length,
            index = that.index,
            slice;

        if (index >= 0 && index < len) {
            slice = slices[index];
            that._uploadSlice(slice, function (r) {
                r = r[0];
                slice.fid = r.SliceID;
                that.index++;
                //暂停成功
                if (that.prg.status == "pausing") {
                    that.prg.status = "pause";
                    that.prg.text = "暂停上传";
                    that.prg.errmsg = "暂停上传";
                    that._updateProgress();
                    if (that._pauseState && that._pauseState.resolve) {
                        that._pauseState.resolve(true, that);
                        that._pauseState.resolve = null;
                        that._pauseState.reject = null;
                    }
                    reject(that.prg.errmsg, that);
                    that.prg.upload += r.SliceSize;
                }
                else {
                    //分片上传成功
                    that.prg.upload += r.SliceSize;
                    that._updateProgress();
                    that._uploadSlices(resolve, reject);
                }
            }, function (r) {
                //暂停失败
                if (that.prg.status == "pausing") {
                    if (that._pauseState && that._pauseState.reject) {
                        that._pauseState.reject("上传分片时出错", that);
                        that._pauseState.resolve = null;
                        that._pauseState.reject = null;
                    }
                }
                reject(r, that);
            });
        }
        else {
            //禁止暂停
            if (that.prg.status == "pausing") {
                that.prg.status = "pause";
                that.prg.text = "暂停上传";
                that.prg.errmsg = "暂停上传";
                that._updateProgress();
                if (that._pauseState && that._pauseState.resolve) {
                    that._pauseState.resolve(true, that);
                    that._pauseState.resolve = null;
                    that._pauseState.reject = null;
                }
                reject(that.prg.errmsg, that);
                that.prg.upload = that.prg.total;
                return;
            }
            that.prg.upload = that.prg.total;
            that._updateProgress();
            resolve(true, that);
        }
    };

    //上传单个分片
    pt._uploadSlice = function (slice, resolve, reject) {
        var that = this,
            config = that.config,
            file = config.file,
            blob;

        blob = file.slice(slice.start, slice.end);
        that._callUploadSliceApi(blob, function (r) {
            resolve(r, that);
        }, function (r) {
            reject(r, that);
        }, slice);
    };

    //调用上传分片 API 
    pt._callUploadSliceApi = function (blob, resolve, reject, slice) {
        var that = this,
            config = this.config;
        if (config.useMsInvoke) {
            that._callMsUploadSliceApi(blob, resolve, reject, slice);
        }
        else {
            that._callRawUploadSliceApi(blob, resolve, reject, slice);
        }
    };

    //直接调用文件服务的 API 来上传分片
    pt._callRawUploadSliceApi = function (blob, resolve, reject, slice) {
        var form = new FormData();
        form.set("file", blob,
            slice ? "slice_" + slice.start + "_" + (slice.end - slice.start) : "slice_x_x");
        form.set("state", "");
        this._post(
            "/File/UploadSlice",
            form,
            resolve,
            reject);
    };

    //调用标准 Web API 来上传分片
    pt._callMsUploadSliceApi = function (blob, resolve, reject, slice) {
        var that = this;
        blob.arrayBuffer().then(function (buffer) {
            var data = arrayBufferToBase64(buffer);
            that._zjMsInvoke(
                "/File/UploadSliceBase64",
                JSON.stringify({
                    "Slices": [{
                        "Data": data,
                        "State": ""
                    }]
                }),
                resolve,
                reject);
        }, function (xhr) {
            console.error(arguments);
            reject("" + xhr.status + " " + xhr.statusText + " " + xhr.responseText, that);
        });
    };

    //直接 POST
    pt._post = function (path, data, resolve, reject, contentType) {
        var that = this,
            config = this.config,
            url = config.url || "";
        var xhr = new XMLHttpRequest();
        xhr.open("POST", url + path, true);
        if (contentType) {
            xhr.setRequestHeader("Content-Type", contentType);
        }
        xhr.onreadystatechange = function () {
            var xhr = this;
            if (this.readyState === XMLHttpRequest.DONE) {
                if (this.status === 200) {
                    var r;
                    try {
                        r = JSON.parse(xhr.responseText);
                        if (r && r.RspCode == "1" && r.Data) {
                            resolve(r.Data, that);
                            return;
                        }
                    }
                    catch (ex) {
                        console.error(ex);
                    }
                }
                var errmsg = "POST " + xhr.responseURL + " "
                    + xhr.status + " " + xhr.statusText + " " + xhr.responseText;
                console.error("Call File Api Error: " + errmsg);
                reject(errmsg, that);
            }
        };
        xhr.onerror = function (xhr) {
            var errmsg = "POST " + xhr.responseURL + " "
                + xhr.status + " " + xhr.statusText + " " + xhr.responseText;
            console.error("Call File Api Error: " + errmsg);
            reject(errmsg, that);
        };
        xhr.send(data);
    };

    //调用 FileService 的 API
    pt._zjMsInvoke = function (path, data, resolve, reject) {
        var that = this;
        $.zjMsInvoke({
            invokeType: "MsPostInvoke",
            success: function (r, succ, xhr) {
                if (r &&
                    r.RspCode == "1" &&
                    r.Data &&
                    r.Data.length &&
                    r.Data[0] &&
                    r.Data[0].RespDatas &&
                    r.Data[0].RespDatas.length &&
                    r.Data[0].RespDatas[0] &&
                    r.Data[0].RespDatas[0].RespCode == "1" &&
                    r.Data[0].RespDatas[0].Data) {
                    try {
                        r = JSON.parse(r.Data[0].RespDatas[0].Data);
                        if (r) {
                            resolve(r, that);
                            return;
                        }
                    }
                    catch (ex) {
                        console.error(ex);
                    }
                }
                var errmsg = "POST " + xhr.responseURL + " "
                    + xhr.status + " " + xhr.statusText + " " + xhr.responseText;
                console.error("Call File Api Error: " + errmsg);
                reject(errmsg, that);
            },
            error: function (xhr) {
                var errmsg = "POST " + xhr.responseURL + " "
                    + xhr.status + " " + xhr.statusText + " " + xhr.responseText;
                console.error("Call File Api Error: " + errmsg);
                reject(errmsg, that);
            },
            Data: [{
                "ServiceName": "FileService",
                "ServiceVersion": "1.0",
                "Funcs": [{
                    "HttpType": null,
                    "InvokeUrl": path,
                    "Data": data
                }]
            }]
        });
    };

    function arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return win.btoa(binary);
    }

    function base64ToArrayBuffer(base64) {
        var binary_string = win.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }

    ZJUploader.getApiUrl = getApiUrl;

    ZJUploader.upload = function (option) {
        const data = option.data || {};
        //注意：ZJUploader 实例不能重用。
        const uploader = new ZJUploader({
            /* 指定待上传的文件，必须为 File 类型。 */
            file: option.file,
            //文件参数：
            module: data.module || '',        //模块名
            submodule: data.submodule || '',  //子模块
            assocID: data.assocID || '',      //业务ID
            uploader: data.uploader || '',    //上传人
            folder: data.folder || '',        //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
            ext1: data.ext1 || '',            //扩展字段 1
            ext2: data.ext2 || '',            //扩展字段 2
            ext3: +(data.ext3 || 0),          //扩展字段 3
            //处理进度
            progress: function (e) {
                if (e.total > 0) {
                    e.percent = 100 * e.upload / e.total;
                }
                else {
                    e.percent = .0;
                }
                option.onProgress(e);
            }
        });

        //开始上传
        var r = uploader.upload();

        r.then(function (r) {
            option.onSuccess({
                name: r.FileName,
                url: r.DownloadPath + '?fname=' + encodeURIComponent(r.FileName),
                data: r
            });
        }, function (errmsg) {
            console.error("Upload fail: " + errmsg, arguments);
            //const isPause = uploader.prg.status == "pause"; //是否用户暂停
            const err = new Error(errmsg);
            option.onError(err);
        });
        return r;
    };

    win.ZJUploader = ZJUploader;

    return ZJUploader;
})(window);
